import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './UserNavItemPopover.scss';
import { Icon } from 'components'
import * as actionCreators from '../../../_store/actions/index';
import { getTranslate } from 'react-localize-redux';

class UserNavItemPopover extends Component {

    constructor(props) {
        super(props);
    
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

	componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
	}

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }

    
    handleClickOutside(event) {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.props.onClickOutside();
        }
    }
    
  	render() {
        if(!this.props.open) {
            return null;
        }
        return (
            <div className={styles.userNavItemPopover} ref={this.wrapperRef}>
                <a onClick={this.props.onAuthLogoutOnServer} className={styles.userNavItemPopoverInner} data-cy="logout-menu">
                    <div className={styles.userNavItemPopoverIcon}>
                        <Icon content="logout" type="image" size="16px"/>
                    </div>
                    <div className={styles.userNavItemPopoverText}>{this.props.translate('menu.logout')}</div>
                </a>
            </div>
        );
	}
}

const mapStateToProps = state => {
    return {
        translate: getTranslate(state.locale)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuthLogoutOnServer: () => dispatch(actionCreators.authLogoutOnServer())
    }
};
export default connect(mapStateToProps,mapDispatchToProps)(UserNavItemPopover);


// WEBPACK FOOTER //
// ./src/components/molecules/UserNavItemPopover/index.js